export default "__VITE_ASSET__C5BR$SJB__"